export enum NO_ROWS_OVERLAY {
  text = 'no_rows_overlay_text',
}
